import React from 'react'
import { Link } from 'react-router-dom'
import { IPostData } from '../../interfaces/post'
import { Image } from 'react-bootstrap';
import "../../assets/css/scss/component/image/_imageTitleDescHoriz.scss"
import preventRightClick from '../../common/preventRightClick';

interface IImageTitleDescHoriz {
    data: IPostData,
    isBigCard: Boolean
}

export default function ImageTitleDescHoriz(props: IImageTitleDescHoriz) {
    return (
        <div className={"d-flex align-items-center flex-sm-nowrap flex-wrap " + (props.isBigCard ? "pb-4 pb-xl-3" : "flex-lg-nowrap pb-3 pb-lg-4 pb-xl-5")}>
            <Link to="/">
                {/* image add w-100 class */}
                {props?.data?.post_image ?
                    <Image src={props.data.post_image} onContextMenu={(e) => preventRightClick(e)} alt="headline" className={""} fluid />
                    : null}
                {/* {
                    props?.data?.post_video ?
                    <video></video>
                } */}
            </Link>
            <div className="image-title-desc-horiz">
                <Link to="/" className={props.isBigCard ? "theme-white bold h4" : "theme-white bold h6"}>
                    {props.isBigCard && props?.data?.post_type ? <span className="theme-green d-inline"> {props?.data?.post_type + ": "}</span> : ""}
                    <span className="d-inline">{props?.data?.post_title}</span>
                </Link>
                {/* <Link to="/" className="theme-white bold h6">
                        {props?.data?.post_title}
                    </Link> */}
                <p className="font-14 theme-white">{props?.data?.post_description}</p>
                {props.isBigCard && props?.data?.post_author ?
                    <h3 className="theme-green h6">{props?.data?.post_author}</h3>
                    : null
                }
            </div>
        </div>
    )
}
